// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"916":"9577bf09","957":"b0974c2f"}[chunkId] + ".chunk.js";
};